import React, { useCallback } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

// components
import Template from "../Template.js";
import FormSelectDialogEdit from "core/FormSelectDialog/variations/FormSelectDialogEdit";
import { DialogStyled } from "core/FormSelectDialog/components/Dialog.js";
import { ControlStyled } from "core/FormSelectDialog/components/Control.js";

// styles
import { convertPxToRem } from "frontend/components/helpers";
import { ModeratorStyled } from "./styles";
const FormSelectDialogEditStyled = styled(FormSelectDialogEdit)`
    ${ControlStyled} {
        width: ${convertPxToRem(200)};
        height: ${convertPxToRem(25)};
    }

    ${DialogStyled} {
        ul {
            z-index: 75;
            width: ${convertPxToRem(250)};
        }
    }
`;

// utils
import * as Utils from "./utils.js";

const Moderator = ({
    batchId,
    onModeratorSelect,
    moderator,
    moderators = [],
    filteredModerators = [],
    currentUser,
    isEditable = true
}) => {
    const onSelect = chosenModerator => {
        onModeratorSelect(chosenModerator.id);
    };

    const mods = !isEditable ? moderators : filteredModerators;

    // get options
    const getOptions = useCallback(() => Utils.getOptions(mods, currentUser), [
        mods
    ]);

    const options = getOptions();

    const getSelectedOption = useCallback(
        () => Utils.getSelectedOption(moderator, options),
        [options, moderator]
    );

    const selectedOption = getSelectedOption();

    return (
        <Template title="Mod" titleFull="Moderators" width={200}>
            <ModeratorStyled data-testid="batch-moderator">
                <FormSelectDialogEditStyled
                    id={`form-select-moderator-${batchId}`}
                    label="Moderator"
                    options={options}
                    selectedOption={selectedOption}
                    setSelectedOption={onSelect}
                    isDisabled={!isEditable}
                />
            </ModeratorStyled>
        </Template>
    );
};

export default Moderator;

// prop-types
Moderator.propTypes = {
    batchId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    onModeratorSelect: PropTypes.func.isRequired,
    moderator: PropTypes.object,
    moderators: PropTypes.array.isRequired,
    filteredModerators: PropTypes.array.isRequired,
    currentUser: PropTypes.object.isRequired,
    isEditable: PropTypes.bool
};
